__turbopack_context__.v({
  "badge": "PageClient-module-scss-module__5uPAOW__badge",
  "coinTab": "PageClient-module-scss-module__5uPAOW__coinTab",
  "coinTabBtn": "PageClient-module-scss-module__5uPAOW__coinTabBtn",
  "linkDisabled": "PageClient-module-scss-module__5uPAOW__linkDisabled",
  "numTag": "PageClient-module-scss-module__5uPAOW__numTag",
  "numTagGold": "PageClient-module-scss-module__5uPAOW__numTagGold",
  "popoverArrow": "PageClient-module-scss-module__5uPAOW__popoverArrow",
  "popoverContent": "PageClient-module-scss-module__5uPAOW__popoverContent",
  "popoverTrigger": "PageClient-module-scss-module__5uPAOW__popoverTrigger",
  "walletHeader": "PageClient-module-scss-module__5uPAOW__walletHeader",
});
